export default __webpack_public_path__ + "static/media/bound-gallery.01fa7e4a.png";